import { useEffect } from 'react';
let lock = 0;
let scrollPosition = 0;
const useLockBodyScroll = shouldLock => {
  useEffect(() => {
    if (shouldLock) {
      if (lock === 0) {
        scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollPosition}px`;
        document.body.style.width = '100%';
      }
      lock++;
    }
    return () => {
      if (shouldLock) {
        lock--;
        if (lock === 0) {
          document.body.style.removeProperty('overflow');
          document.body.style.removeProperty('position');
          document.body.style.removeProperty('top');
          document.body.style.removeProperty('width');
          window.scrollTo(0, scrollPosition);
        }
      }
    };
  }, [shouldLock]);
};
export default useLockBodyScroll;